import { render, staticRenderFns } from "./ColumnViewTable.vue?vue&type=template&id=d992acf2&scoped=true&"
var script = {}
import style0 from "./ColumnViewTable.vue?vue&type=style&index=0&id=d992acf2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d992acf2",
  null
  
)

export default component.exports